import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  senha: Yup.string().senha().required(mensagemPadrao),
  repetirSenha: Yup.string()
    .required(mensagemPadrao)
    .oneOf([Yup.ref('senha'), null], 'As senhas não conferem')
})
